import { inject, Injectable } from '@angular/core';
import { ApiService } from 'src/app/abstract-classes/api.service/api.service';
import { GemstoneType } from 'src/app/interfaces/gemstone-type';
import { StoneTypesProviderService } from 'src/app/providers/stone-types/stone-types.provider.service';

@Injectable({
  providedIn: 'root'
})
export class StoneTypesService extends ApiService<GemstoneType, StoneTypesProviderService> {
  private providerService = inject(StoneTypesProviderService);
  protected override get provider(): StoneTypesProviderService {
    return this.providerService;
  }
}
